import { jsx as c } from "react/jsx-runtime";
import { e as o, f as t, g as f } from "../../vendor-Dd6qj6gJ.js";
import { c as a } from "../../styles.module-C5RaAp_v.js";
function i({
  palette: r = [
    "#994228",
    "#D96534",
    "#FC8F58",
    "#FFBA91",
    "#FFCF4D",
    "#A5D154",
    "#5ED6A4",
    "#00B26E",
    "#00875A",
    "#7DB1FA",
    "#397EED",
    "#1F59C4",
    "#7A2C94",
    "#D869FA",
    "#B1B4B9",
    "#676D78"
  ]
}) {
  return /* @__PURE__ */ c(o, { className: a.colorSwatchPicker, children: r.map((e) => /* @__PURE__ */ c(
    t,
    {
      color: e,
      className: a.colorSwatchItem,
      children: /* @__PURE__ */ c(f, { className: a.colorSwatch })
    },
    String(e)
  )) });
}
export {
  i as ColorSwatchPicker
};
